import React, { useState } from 'react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Button, Card, TextField, Typography } from '@mui/material';
import api from '@/lib/httpClient';
import { showErrorToast, showSuccessToast } from '@/utils/toast-utils';

export const HelpSupportContactCard: React.FC = () => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    const trimmed = message.trim();
    if (!trimmed || sending) return;

    setSending(true);
    try {
      await api.post('/knowledgebase', { message: trimmed });
      showSuccessToast('Message sent', 'Your message has been sent successfully.');
      setMessage('');
    } catch (error) {
      showErrorToast(error, 'Failed to send message');
    } finally {
      setSending(false);
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '20px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 4px rgba(0,0,0,0.07)',
        px: '22px',
        py: 3,
      }}
    >
      <Typography sx={{ fontSize: 28, lineHeight: 1.15, fontWeight: 600, color: '#000' }}>Need More Help?</Typography>
      <Typography sx={{ mt: 1, fontSize: 14, color: '#6a7282' }}>Send us your query or report an issue.</Typography>

      <TextField
        fullWidth
        multiline
        minRows={4}
        label="Message *"
        placeholder="Leave your message here..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={sending}
        variant="outlined"
        sx={{
          mt: 3,
          '& .MuiInputBase-root': {
            alignItems: 'flex-start',
            fontSize: 14,
          },
        }}
      />

      <Button
        fullWidth
        variant="contained"
        endIcon={<SendOutlinedIcon sx={{ fontSize: 16 }} />}
        onClick={handleSend}
        disabled={sending || !message.trim()}
        sx={{
          mt: 3,
          height: 35,
          borderRadius: '8px',
          textTransform: 'none',
          fontSize: 14,
          fontWeight: 500,
          backgroundColor: '#20aedc',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#1a9cc7',
            boxShadow: 'none',
          },
        }}
      >
        {sending ? 'Sending...' : 'Send Message'}
      </Button>
    </Card>
  );
};
